import React, { memo, useState } from 'react';
import ModalWithPattern from './ModalWithPattern';
import styled from '@emotion/styled';
import { IsMobileViewPort } from '../../../utils/helpers';
import { Typography } from '@material-ui/core';
import { getPatternModal } from '../../../style';
import { ButtonDiv } from '../../../modules/QuickOfferModal/quickOfferModalStyle';
import Button from '../../../atoms/buttons/Button';

const TutorialContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
});

const StyledSpan = styled('span')({
  fontSize: 12,
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
    color: '#2490DE',
  },
});

const CustomTooltipWrapper = styled('div')({
  display: 'inline-flex',
  justifyContent: 'center',
});

const OfferText = styled(Typography)({
  fontSize: 13,
  fontStyle: 'normal',
  cursor: 'pointer',
  fontWeight: 400,
  color: '#8392A7',
  '&:hover': {
    textDecoration: 'underline',
    color: '#2490DE',
  },
});

const TitleWrapper = styled('h1')(() => ({
  color: getPatternModal().titleColor,
  fontSize: 28,
  fontWeight: 700,
  lineHeight: '26px',
  letterSpacing: '-0.56px',
  margin: '20px 0 0 0',
}));

const HelpIconWrap = styled('div')({
  marginTop: 2,
  marginLeft: 4,
});

const mobileOverlayStyle = {
  borderRadius: 10,
  height: '100%',
  width: '90%',
  padding: '0 10%',
  left: '-5%',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

const mobileContentStyle = {
  borderRadius: 10,
  maxHeight: 500,
  top: '50%',
  height: 'auto',
  transform: 'translate(0, -50%)',
};

const HelpIcon = ({ color = '#2B8FD7' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M5.99823 9.75C6.20774 9.75 6.38542 9.67767 6.53125 9.53302C6.67708 9.38835 6.75 9.21127 6.75 9.00177C6.75 8.79225 6.67767 8.61458 6.53302 8.46875C6.38835 8.32292 6.21127 8.25 6.00177 8.25C5.79226 8.25 5.61458 8.32233 5.46875 8.46698C5.32292 8.61165 5.25 8.78873 5.25 8.99823C5.25 9.20775 5.32233 9.38542 5.46698 9.53125C5.61165 9.67708 5.78873 9.75 5.99823 9.75ZM6.00431 12C5.17852 12 4.40104 11.8438 3.67188 11.5312C2.94271 11.2188 2.30469 10.7891 1.75781 10.2422C1.21094 9.69531 0.78125 9.05751 0.46875 8.32878C0.15625 7.60004 0 6.8214 0 5.99284C0 5.16428 0.15625 4.38802 0.46875 3.66406C0.78125 2.9401 1.21094 2.30469 1.75781 1.75781C2.30469 1.21094 2.94249 0.78125 3.67122 0.46875C4.39996 0.15625 5.1786 0 6.00716 0C6.83572 0 7.61198 0.15625 8.33594 0.46875C9.0599 0.78125 9.69531 1.21094 10.2422 1.75781C10.7891 2.30469 11.2188 2.94127 11.5312 3.66756C11.8438 4.39386 12 5.16991 12 5.99569C12 6.82148 11.8438 7.59896 11.5312 8.32812C11.2188 9.05729 10.7891 9.69531 10.2422 10.2422C9.69531 10.7891 9.05873 11.2188 8.33244 11.5312C7.60614 11.8438 6.83009 12 6.00431 12ZM6.05019 3.34375C6.30358 3.34375 6.53044 3.42281 6.73077 3.58094C6.93109 3.73905 7.03125 3.9367 7.03125 4.17387C7.03125 4.39129 6.96514 4.58854 6.83292 4.76562C6.7007 4.94271 6.54806 5.10417 6.375 5.25C6.13542 5.45833 5.91667 5.6875 5.71875 5.9375C5.52083 6.1875 5.42188 6.46875 5.42188 6.78125C5.42188 6.9375 5.4775 7.06771 5.58875 7.17188C5.7 7.27604 5.82979 7.32813 5.97813 7.32813C6.14549 7.32813 6.28733 7.27344 6.40364 7.16406C6.51996 7.05469 6.59375 6.91667 6.625 6.75C6.66667 6.53125 6.76042 6.33783 6.90625 6.16973C7.05208 6.00165 7.20833 5.8412 7.375 5.68839C7.61458 5.46905 7.81771 5.22036 7.98438 4.94234C8.15104 4.66431 8.23438 4.36582 8.23438 4.04688C8.23438 3.51562 8.01823 3.08073 7.58594 2.74219C7.15365 2.40365 6.65058 2.23438 6.07675 2.23438C5.68029 2.23438 5.30536 2.32292 4.95197 2.5C4.59857 2.67708 4.30646 2.93368 4.07563 3.2698C3.99396 3.3824 3.97135 3.50621 4.00781 3.64122C4.04427 3.77624 4.11979 3.89062 4.23438 3.98438C4.38021 4.09896 4.53646 4.13281 4.70312 4.08594C4.86979 4.03906 5.01042 3.94271 5.125 3.79688C5.23958 3.65104 5.37682 3.53906 5.5367 3.46094C5.69658 3.38281 5.86774 3.34375 6.05019 3.34375Z"
        fill={color}
      />
    </svg>
  );
};

interface OffersTutorialProps {
  linkStyle?: React.CSSProperties;
  isAttractiveUser?: boolean;
}

const OffersTutorialModal = ({ linkStyle = {}, isAttractiveUser = false }: OffersTutorialProps): JSX.Element => {
  const [showOffersTutorial, setShowOffersTutorial] = useState(false);

  const handleOnLinkClick = () => {
    if (!showOffersTutorial) {
      setShowOffersTutorial(true);
    }
  };

  const handleCloseModal = () => {
    setShowOffersTutorial(false);
  };

  return (
    <>
      <StyledSpan style={linkStyle}>
        <CustomTooltipWrapper onClick={() => handleOnLinkClick()}>
          <OfferText>{isAttractiveUser ? 'What is an offer request?' : `What's an offer`}</OfferText>
          <HelpIconWrap>
            <HelpIcon />
          </HelpIconWrap>
        </CustomTooltipWrapper>
      </StyledSpan>
      <ModalWithPattern
        dataTestID="offers-tutorial-modal"
        isModalOpen={showOffersTutorial}
        modalContentLabel="Offers Tutorial"
        closeOnOverlayClick
        closeRequest={handleCloseModal}
        closeBtnClassName="offers-tutorial-close"
        closeBtnDataTestId="offers-tutorial-close"
        onCloseClick={handleCloseModal}
        customOverlayStyle={IsMobileViewPort ? mobileOverlayStyle : {}}
        customContentStyle={IsMobileViewPort ? mobileContentStyle : { maxWidth: 500 }}
      >
        <TutorialContainer>
          <TitleWrapper style={{ marginTop: IsMobileViewPort ? '35px' : '20px' }}>
            {isAttractiveUser ? `What’s an Offer Request?` : `What's an Offer?`}
          </TitleWrapper>
          <TitleWrapper
            style={{
              color: getPatternModal().headerColor,
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '21px',
              letterSpacing: '-0.32px',
              marginTop: 20,
            }}
          >
            {isAttractiveUser
              ? "It's the amount you suggest for the Generous member to offer you for a first date."
              : 'It’s is an incentive you give to an Attractive member; a gift intended to encourage them to go on a first date.'}
          </TitleWrapper>
          <ButtonDiv style={{ marginTop: 20, marginBottom: 18, borderTopWidth: 0 }}>
            <Button
              buttonType="primaryRed"
              onClick={() => setShowOffersTutorial(false)}
              type="submit"
              customStyle={{ borderRadius: '4px !important' }}
            >
              OK
            </Button>
          </ButtonDiv>
        </TutorialContainer>
      </ModalWithPattern>
    </>
  );
};

export default memo(OffersTutorialModal);
